<template>
  <v-card-text :style="`line-height: 1.4em; min-height: ${dense ? '0' : '84.64px'}; position: relative;`" class="d-flex align-start pa-0">
    
    <div class="pt-3">
      <slot name="hint">
        <v-tooltip top right v-if="hint">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" style="padding-right: .39em; transform: translateY(-5px)">
              mdi-help-circle-outline
            </v-icon>
          </template>
          <span style="white-space: pre-wrap" v-html="hint"></span>
        </v-tooltip>
      </slot>
    </div>

    <div style="flex-grow: 1;">
      <div class="info-label-container" :style="`color: var(--v-${!invalid ? 'secondary' : 'error'}-base);`" >
        <slot name="label">
          <span class="info-label" style="font-size: .9em; font-style: italic; display: inline-block; width: 100%">
            {{label}}
          </span>
        </slot>
      </div>
      <div style="padding-left: 1.2em; padding-top: 0.3em; line-height: 1.6em; font-size: 1.2em; color: #020202" class="info-value" :class="{'invalid': invalid}">
        <v-skeleton-loader style="padding: .4em 0; line-height: .8em; margin: 0 !important" v-if="loading" type="text"></v-skeleton-loader>
        <slot v-else />
      </div>
      <div v-if="message" :style="`transform: translateY(-5px); font-size: .8em; line-height: 1em; padding-left: 1.2rem; color: var(--v-${!invalid ? 'secondary' : 'error'}-base);`">{{message}}</div>
    </div>
  </v-card-text>
</template>

<script>
export default {
  props: {
    label: String,
    hint: String,
    loading: Boolean,
    dense: Boolean,
    invalid: Boolean,
    message: [String, undefined]
  }
}
</script>

<style scoped>
.info-label-container {
  padding-left: .3em
  /* margin-bottom: -.7em; */
  /* background: red; */
}

.info-value {
  position: relative;
  border-top: solid 1px var(--v-secondary-base);
  border-top-left-radius: .3em;
}

.info-value::before {
  content: " ";
  /* height: .8em; */
  height: calc(50% + .15em);
  width: .8em;
  position: absolute;
  top: 0em;
  left: 0;

  /* background: red; */
  border-left: solid 1px var(--v-secondary-base);
  border-bottom: solid 1px var(--v-secondary-base);
  border-top-left-radius: .3em;
  border-bottom-left-radius: .3em;
}

.invalid {
  border-top: solid 1px var(--v-error-base);
}

.invalid::before {
  border-left: solid 1px var(--v-error-base);
  border-bottom: solid 1px var(--v-error-base);
}

</style>

<style>
.v-skeleton-loader__text {
  margin: 0 !important
}
</style>